import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/tokens.css";
import "./styles/design-system.css";
import "./index.css";
import { CartProvider } from "./context/CartContext";
import axios from "axios";
import { apiClient } from "./api/axios";
import {
    installSessionRevokedFetch,
    installSessionRevokedAxios,
} from "./utils/sessionRevoked";

// Sessione revocata lato server (401 + X-Session-Revoked): chiusura globale.
installSessionRevokedFetch();
installSessionRevokedAxios(axios);
installSessionRevokedAxios(apiClient);

// Cattura ?ref= una sola volta, prima del render
(function captureReferralFromUrl() {
    try {
        const params = new URLSearchParams(window.location.search);
        const ref = params.get("ref");
        if (ref) {
            localStorage.setItem("pendingReferralCode", ref);
            // pulisci l'URL (senza ricaricare)
            params.delete("ref");
            const q = params.toString();
            const newUrl =
                window.location.pathname +
                (q ? `?${q}` : "") +
                window.location.hash;
            window.history.replaceState({}, "", newUrl);
        }
    } catch { }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <CartProvider>
        <App />
    </CartProvider>
);
